<template>
  <div :class="{hidden: !visible}" class="stats-tile">
    <v-alert v-if="showError" type="error" value="true" dismissible class="stats-tile__alert" @click="showError=false">
      Failed to load statistics.
    </v-alert>
    <transition name="fade-transition">
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        class="stats-tile__loader"
        size="22"
      />
    </transition>
    <refresh-button :show="true" :disabled="isDisabled" class="hidden-md-and-up" @click="handleRefreshClick"/>

    <p class="mb-1">
      <strong class="stats-tile__provider-count">{{stats.providerCounters.total}} </strong>
      <strong class="stats-tile__provider-label">{{companies}}</strong>
      <span class="d-block"> on doxo in {{area}} (last 90 days)</span>
    </p>
    <p class="mb-0">
      <strong class="stats-tile__provider-stat">{{stats.providerCounters.national}}</strong> are national companies <br>
      <strong class="stats-tile__provider-stat">{{stats.providerCounters.regional}}</strong> are regional companies
    </p>
    <p>
      <strong class="stats-tile__provider-stat">{{stats.payments.avg}}</strong> avg. bill payment made to {{companiesForAvgBillEntry}} in {{area}}
    </p>
    <div class="stats-tile__users-stats">
      <p class="mb-0">
        Data shown is based on <strong class="stats-tile__user-count">{{stats.userCounter}}</strong> doxo user accounts in this area.
      </p>
      <p class="hidden-md-and-up">
        <a :href="siteUrls.aboutPath">Learn more</a> about doxo Payment Data
      </p>
    </div>
  </div>
</template>

<script>
  import { apiPath, geoName, serviceTypeName } from './utils'
  import axios from 'axios'
  import RefreshButton from '@/components/heatmap/RefreshButton.vue'
  import geoRefreshBtnMixin from '@/mixins/geo-refresh-btn'
  import { mapActions, mapState } from 'vuex'
  import siteUrls from '@/helpers/site_urls'
  import airbrake from '@/helpers/airbrake'

  export default {
    mixins: [geoRefreshBtnMixin],
    components: {
      RefreshButton
    },
    mounted () {
      this.showError = this.stats.timed_out
    },

    props: {
      visible: {type: Boolean, required: true}
    },

    watch: {
      '$route.params' () {
        this.isDisabled = true
        this.refreshStats()
      },
      mapBounds () {
        if (this.mapBoundsChangedByUser) {
          this.isDisabled = false
          this.showError = false
        }
      }
    },

    data () {
      return {
        isDisabled: true,
        loading: false,
        showError: false,
        siteUrls: siteUrls
      }
    },

    computed: {
      ...mapState('geo', ['stats']),
      ...mapState('heatmap', ['mapBounds', 'mapBoundsChangedByUser', 'selectedGeo']),
      serviceTypeName: serviceTypeName,
      area: geoName,

      companies () {
        return this.serviceTypeName ? `${this.serviceTypeName} Billers` : 'Billers'
      },

      companiesForAvgBillEntry () {
        return this.serviceTypeName ? `${this.serviceTypeName} companies` : 'these companies'
      }
    },

    methods: {
      ...mapActions('geo', ['updateStats']),
      ...mapActions('heatmap', ['setSelectedGeo', 'setHeatmapState']),

      refreshStats () {
        this.loading = true
        this.showError = false
        axios.get(apiPath(this.$route, `/g_api/providers_and_users_stats`))
          .then(response => {
            this.loading = false
            this.updateStats(response.data)
            this.showError = response.data.timed_out
          })
          .catch(err => {
            this.loading = false
            this.showError = true
            airbrake.notify(err)
          })
      }
    }
  }
</script>

<style lang="stylus">
  @require '~styles/components/_stats_tile'
</style>



// WEBPACK FOOTER //
// frontend/src/pages/Geo/components/StatsTile.vue